var exports = {
  "n": "xaee3c4fa--035bf3--link",
};

module.exports = exports;
